import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import { languages } from "./i18nLanguages";
import ko from "./ko.json";

i18n
  // i18n을 react-i18next로 전달
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      ko: {
        translation: ko,
      },
    },
    lng: languages.ko,
    fallbackLng: languages.ko,
    interpolation: {
      // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      escapeValue: false,
    },
  });
